import { App } from 'antd';
import { useCallback } from 'react';
import { DormitoryHttp } from '@/services';
import { useTranslation } from 'react-i18next';

export default function useDormitoryCancelConfirm({ onOk = undefined }) {
  const { modal } = App.useApp();
  const [t] = useTranslation(['common', 'dormitory']);
  const show = useCallback((item: DormitoryLeaveEntity) => {
    modal?.confirm({
      onOk: async () => {
        await DormitoryHttp.updateLeaveReport(item.id, {
          status: 'CANCEL_BY_OWNER'
        });
        if (onOk) onOk();
      },
      content: t('dormitory:messages.confirm-cancel-request'),
      cancelText: t('common:labels.no'),
      okText: t('common:labels.yes'),
      okButtonProps: { size: 'middle' },
      cancelButtonProps: { size: 'middle' },
    });
  }, [modal, onOk, t]);

  return show;
}
